// Dev-only logger. In production builds (NODE_ENV === 'production') all
// methods become no-ops so internal errors don't leak into browser consoles.
const isDev = process.env.NODE_ENV !== "production";

export const logger = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
};

export default logger;
